export const tempdata = {
    "id" : 1,
    "code" : "ЦО-10023",
    "name" : "Использование информационных технологий в повседневной жизни",
    "date" : "01.01.2020",
    "owner" : "ЦОПП",
    "ownerId": 1,
    "ispublic" : true,
    "moduleCount" : 2,
    "programCount" : 3,
    "statusId": 1,
    "statusName" : "активный",
    "typeId":1,
    "typeName":"общедоступный",
    "memberCount":32,
    "fileId":null
  };

export const tempquestions = [
  {
    id: 1,
    name: "",
    number: 1,
    description: "",
    templateId: 1,
    isrequired: true
  },
  {
    id: 2,
    name: "",
    number: 2,
    description: "",
    templateId: 2,
    isrequired: true
  }
];

export const templateList = [
  {id: 1, name: "Текст"},
  {id: 2, name: "Дата"},
  {id: 3, name: "Время"},
  {id: 4, name: "Один из списка"},
  {id: 5, name: "Несколько из списка"},
  {id: 6, name: "Выпадающий"}
];

export const tempconnectList = [
  {
    id: 1,
    isName: "Конструктор образовательных программ",
    programName: "Дизайнер хлебобулочных изделий",
    typeId: 1,
    typeName: "Тестирование",
    dateBegin: "01.01.2020",
    dateEnd: "30.01.2020"
  },
  {
    id: 2,
    isName: "База данных ЦОПП",
    programName: "Су-вид повар",
    typeId: 1,
    typeName: "Тестирование",
    dateBegin: "01.01.2020",
    dateEnd: "30.01.2020"
  }
];

export const tempconnect = {
  id: 1,
  isId: 1,
  programId: 1,
  typeId: 1,
  dateBegin: "01.01.2020",
  dateEnd: "30.01.2020"
}
